__turbopack_context__.v({
  "container": "ManagersSection-module-scss-module__vdElhq__container",
  "emailLink": "ManagersSection-module-scss-module__vdElhq__emailLink",
  "listContent": "ManagersSection-module-scss-module__vdElhq__listContent",
  "title": "ManagersSection-module-scss-module__vdElhq__title",
});
